import { createFileRoute } from '@tanstack/react-router';

import { TranslationBrowse } from '@/module/Author/Translation/TranslationBrowse';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TranslationBrowse />;
}
